import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OtpDialog from "components/reusable/OtpDialog";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { apiGet, apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function EAlbaniaPaymentDetails() {
  const { orderNumber } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [paymentDetails, setPaymentDetails] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestBody, setRequestBody] = useState({});

  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const getPaymentDetails = async () => {
    try {
        var response = await apiGet(`${pathObj.pendingEAlbaniaTransactionDetails}?id=${orderNumber}`);
        if (response.data.success) {
          setPaymentDetails(response.data.results);
        } else {
          notification.error(response.data.message);
          navigate(-1);
        }

    //   setPaymentDetails({
    //     order_number: "#123456",
    //     order_amount: 1000,
    //     service_name: "Aplikim për pajisje me nënshkrim elektronik për të punësuarit dhe subjektet tatimpaguese(TEST)",
    //     currency: "ALL",
    //     order_date: new Date(),
    //     provider_name: "e-Albania",
    //     institution_code: "12345",
    //     treasure_branch: "67890",
    //     obligations: [
    //       {
    //         service_name: "Pagese per paisje me nenshkrim elektronik. Denis Cerri",
    //         order_amount: 500,
    //         treasure_branch: "67891",
    //       },
    //       {
    //         service_name: "Electricity 3",
    //         order_amount: 500,
    //         treasure_branch: "67892",
    //       },
    //     ],
    //   });
    } catch (err) {}
  };

  useEffect(() => {
    getPaymentDetails();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const requestBody = {
        id: orderNumber,
        comment: data.comment,
      };
      setRequestBody(requestBody);
      const res = await apiPost(pathObj.pendingEAlbaniaTransactionSendOTP, requestBody);
      if (res.data.success) {
        setShowOtpDialog(true);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  if (!paymentDetails) {
    return (
      <>
        <Toolbar title={t("O_DETAILS")} showBackBtn={true} />
        <div className="flex w-full justify-center mt-5">
          <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
        </div>
      </>
    );
  }

  return (
    <>
      <Toolbar title={t("O_DETAILS")} showBackBtn={true} />
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="px-4 pb-4 rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="bg-card flex justify-start gap-5 p-[1rem]">
              <img src="/images/E-Albania.svg" className="h-[2rem]" alt="E-Albania Logo" />
              <div className="font-medium text-start text-white">
                <div>{paymentDetails.service_name}</div>
                <div className="grid grid-cols-2 text-xs w-full mt-4">
                  <div className="col-span-1">{t("PROVIDER")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{paymentDetails.provider_name}</div>

                  <div className="col-span-1">{t("ORDER_DATE")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{dayjs(paymentDetails.order_date).format("DD/MM/YYYY")}</div>

                  <div className="col-span-1">{t("ORDER_NUMBER")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{paymentDetails.order_number}</div>

                  <div className="col-span-1">{t("INSTITUTION_CODE")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{paymentDetails.institution_code}</div>

                  <div className="col-span-1">{t("TREASURE_BRANCH")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{paymentDetails.treasure_branch}</div>
                </div>
              </div>
            </div>

            {paymentDetails.obligations && paymentDetails.obligations.length > 0 && (
              <>
                <div className="text-lg font-medium  mt-5 mb-2">{t("RECEIVERS")}</div>
                {paymentDetails.obligations.map((it) => (
                  <div className="bg-card p-4 font-medium mb-3 text-white">
                    <div className="flex justify-between items-center">
                        <div className="text-lg font-medium">{it.service_name}</div>
                        <div className="font-medium text-yellow-600 w-full text-end">{it.order_amount} {paymentDetails.currency}</div>
                    </div>
                    <div className="pt-3 flex justify-between items-center">
                        <div className="text-xs text-gray-500">{t('TREASURE_BRANCH')}</div>
                        <div className="text-xs text-gray-500 text-end">{it.treasure_branch}</div>
                    </div>
                  </div>
                ))}
              </>
            )}

            <div className="text-lg font-medium  mt-5 mb-2">{t("AMOUNT")}</div>
            <div className="bg-card p-4 rounded-lg">
              <div className="flex justify-start gap-3 items-center">
                <div className="font-medium text-lg text-white">{paymentDetails.currency}</div>
                <input
                  type="number"
                  id="amount"
                  inputType="numeric"
                  disabled
                  value={paymentDetails.order_amount}
                  className="inputform border-0 text-heading text-white font-medium text-sm rounded-base block w-full px-3 rounded-lg py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("AMOUNT_FIELD")}
                  onKeyDown={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                  {...register("amount", {
                    required: t("AMOUNT_EMPTY"),
                  })}
                  required
                />
              </div>
            </div>

            <div className="text-lg font-medium  mt-5 mb-2">{t("DESCRIPTION")}</div>
            <input
              type="text"
              id="description"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("comment", {
                required: "",
              })}
            />

            <div className="w-full mt-[5rem]">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("PAY")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      {showOtpDialog && (
        <OtpDialog
          otpURL={pathObj.pendingEAlbaniaTransactionSendOTP}
          otpConfirmURL={pathObj.payEAlbaniaTransaction}
          body={requestBody}
          onSuccess={(message) => {
            navigate("/payments/ealbania");
            notification.success(message || t("OPERATION_SUCCESS"));
          }}
          onClose={() => {
            setShowOtpDialog(false);
          }}
        />
      )}
    </>
  );
}

export default EAlbaniaPaymentDetails;
